import styled from 'styled-components';
import { ImpactCategoryId } from '@upright/common/model/input/impacts/impact-categories';
import { Dimension, Valence } from '../../../../../../../common/model/types';
import { friendlyShortImpactTitle } from '../../../../../../../common/utils';
import { BouColor } from '../../../../../generic/global/bou-colors';
import { FadeIn } from '../../../../../generic/layout/fade-in';
import { useValuesSelectorContext } from '../context';
import { stepRange, ValueSelectorRadioButton } from './shared';
import { usePushGtmEvent } from '@upright/ui/common/generic/components/google-tag-manager/use-push-gtm-event';
import { CustomGtmEvent } from '@upright/ui/common/generic/components/google-tag-manager/use-push-gtm-event/payloads';

interface Props {
  impactCategory: ImpactCategoryId;
  valence: Valence;
  dimension: Dimension;
  index: number;
}

export function ImpactRow(props: Props) {
  const context = useValuesSelectorContext();
  const stateHooksOfValence = context.stateHooks[props.dimension][props.valence];
  const [valueOfValence, setValueOfValence] = stateHooksOfValence.valueStateHookOfValence;
  const [value, setValue] = stateHooksOfValence.stateHooksOfImpactCategories[props.impactCategory];
  const pushGtmEvent = usePushGtmEvent();

  return (
    <Root index={props.index}>
      <Title>
        <FadeIn>{friendlyShortImpactTitle(props.impactCategory)}</FadeIn>
      </Title>
      {stepRange.map(index => (
        <td key={index}>
          <FadeIn>
            <ValueSelectorRadioButton
              checked={value === index}
              onSelect={() => {
                if (valueOfValence !== index) {
                  setValueOfValence(undefined, false);
                }
                setValue(index, true);
              }}
              onClick={() => {
                pushGtmEvent({
                  event: CustomGtmEvent.VALUE_SET_CATEGORY_TWEAK,
                  data: {
                    impactCode: props.impactCategory,
                    valence: props.valence,
                    weight: index,
                  },
                });
              }}
              grayWhenUnchecked
            />
          </FadeIn>
        </td>
      ))}
    </Root>
  );
}

const Root = styled.tr<{ index: number }>`
  background-color: ${props => !(props.index % 2) && BouColor.TOOL_TABLE_BACKGROUND_LIGHT_GRAY};
  td {
    padding-top: 0.3em;
    padding-bottom: 0.3em;
  }
`;

const Title = styled.td`
  padding-left: 3em;
  margin-right: 3em;
`;
